import {createDefaultLogger} from '@hconnect/common/logging'

export {AppInsightsAdapter} from '@hconnect/common/logging'
export type {Event} from '@hconnect/common/logging'

// Add 'azure' as target for testing azure tracking locally
export const logger = createDefaultLogger('predict')
